import { MouseEventHandler } from "react";

export type Mark = { value: number; label: string };

export interface SliderProps {
  /**
   * The ID for when the slider is used, say, in a form.
   */
  id?: string;
  name?: string;
  /**
   * Min value
   */
  min?: number;
  /**
   * Max value
   */
  max?: number;
  /**
   * Default value of the slider. Make sure it isn't smaller or larger than the min/max.
   */
  defaultValue?: number;
  /**
   * Value of the slider. Make sure it isn't smaller or larger than the min/max.
   */
  value?: number;
  /**
   * The onChange event of the slider.
   */
  onChange?: (value: number) => void;
  onMouseUp?: MouseEventHandler<HTMLInputElement>;
  onMouseDown?: MouseEventHandler<HTMLInputElement>;
  /**
   * The step of the slider.
   */
  step?: number;
  /**
   * The marks of the slider. If undefined, the slider will not have any marks or labels
   */
  marks?: Mark[];
  disabled?: boolean;
  hideThumb?: boolean;
  "data-test"?: string;
}

export type SliderMarksProps = {
  marks?: Mark[];
  value?: number;
  min: number;
  max: number;
  disabled: boolean;
  id?: string;
  hideThumb?: boolean;
};

export enum SLIDER_MARK_STATE {
  EQUAL = "Equal",
  GREATER = "Greater",
  SMALLER = "Smaller",
}

export type SliderMarkProps = {
  disabled: boolean;
  state: SLIDER_MARK_STATE;
  left: string;
  hideThumb?: boolean;
};
